import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ABOUTIMAGES } from '../_model/aboutImages';
import { baseUrl, httpOptions } from './url';


@Injectable({
  providedIn: "root"
})
export class MenuServiceService {
  openStatus;
  constructor(private http: HttpClient) {}

  // companyImages = new EventEmitter();
  // shipyardImages = new EventEmitter();

  changesOpen(openStatus) {
    return (this.openStatus = openStatus);
  }

  getMainMenu(): Observable<any> {
    return this.http.get(baseUrl + "ros.php/" + "{navbar_menu}");
  }

  // https://ros.com.sg/demo/rosapi/menu.php/%7babout_menu%7d
  getaboutMenu(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "about_menu");
  }

  getenggMenu(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "engg_solutions");
  }

  getDocMenu(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "docs_menu");
  }

  getprojectMenu(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "projectvideo_menu");
  }

  getHomeContent(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "home_page");
  }

  getsafetyContent(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "safety");
  }

  getContactContent(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "contact_us");
  }

  getSafetyImages(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "safety_img");
  }

  getContactImages(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "contact_img");
  }

  getCareerImages(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "career_img");
  }

  getAboutImages(): Observable<ABOUTIMAGES[]> {
    return this.http.get<ABOUTIMAGES[]>(baseUrl + "ros.php/" + "about_images");
  }

  companyDetails(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "company_profile");
  }

  shipyardContent(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "shipyard");
  }

  ourTeamContent(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "our_team");
  }

  projectVideo(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "project_videos");
  }

  safety(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "our_safety");
  }
  ceritification_image(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "certification_img");
  }
  awards_image(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "awards_img");
  }
  shipyard_pts(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "shipyard_points");
  }
  safety_pts(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "safety_points");
  } 
   getAddress(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "contact_address");
  }
  clientImage(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "clients_img");
  }  
  principleImage(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + "principle_img");
  }
  document(doctype): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + doctype);
  }
  getValues(tble): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + tble);
  }
  postValues(tbl, input): Observable<any> {
    return this.http.post<any>(`${baseUrl + "ros.php/" + tbl}`, input);
  }
  removeuser(tbl, id): Observable<void> {
    console.log(tbl, id);
    const dataInput = tbl + "/" + id;
    return this.http.delete<void>(`${baseUrl + "delete_one.php/" + dataInput}`);
  }
  getList(tbl): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/"+ tbl);
  }
  postList(tbl, input, id): Observable<any> {
    console.log(tbl, input, id);
    const dataInput = tbl + "/" + id;
    return this.http.post<any>(`${baseUrl + "ros_admin.php/" + dataInput}`, input);
  }
  getListId(tbl,key) {
    return this.http.get<any>(baseUrl+ "ros.php/" + tbl +"/"+ key);
  }
  changePassword(input) {
    return this.http.post<any>(baseUrl + "changePassword.php" ,input);
  }
}
